module.exports = __webpack_public_path__ + "media/assets/2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/2.svg
// module id = 13
// module chunks = 0